import { T_userInfo } from '@/types'
import { http } from '@/utils/http'

/**
 * 登录表单
 */
export interface ILoginForm {
  username: string
  password: string
  code: string
  uuid: string
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return http.post<T_userInfo>('/api/consumer/server-shop/user/getDetailById')
}
